






























































































































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IImportMapping,
  IImportProviderData,
  IStepMappingsProviderData,
  IStepMappingsProviderMethods
} from "@/models/imports";
import { UpmindObjectMap, UpmindObjectTypes } from "@/data/enums/objects";
import _ from "@/boot/lodash";

@Component
export default class StepMappingsTable extends Vue {
  @Inject({ from: "mappingProvider" })
  public readonly $mappingProvider!: () => IStepMappingsProviderData;

  @Inject({ from: "mappingMethods" })
  public readonly $mappingMethods!: IStepMappingsProviderMethods;

  @Inject({ from: "importProvider" })
  public readonly $importProvider!: () => IImportProviderData;

  public isContinuing = false;

  public get $mappingData() {
    return this.$mappingProvider();
  }

  public get $importData() {
    return this.$importProvider();
  }

  public gotoExternalUrl(url) {
    window.open(url);
  }

  public getObjectName(object_type: IImportMapping["object_type"]) {
    const map = UpmindObjectMap()[object_type];
    return (this.$_.get(map, "name", object_type) as string).toLowerCase();
  }

  public getMappedObjectSummary(
    object_type: IImportMapping["object_type"],
    object: IImportMapping["object"]
  ) {
    const values = {};
    switch (object_type) {
      case UpmindObjectTypes.CUSTOM_FIELD:
        this.$set(values, "name", object.name);
        this.$set(values, "display_type", object.display_type);
        this.$set(values, "id", object.id);
        break;
      case UpmindObjectTypes.GATEWAY:
        this.$set(values, "name", object.name);
        this.$set(values, "provider", object.gateway_provider.name_translated);
        this.$set(values, "id", object.id);
        break;
      case UpmindObjectTypes.PROVISION_CONFIGURATION:
        this.$set(values, "name", object.name);
        if (_.has(object, "field_values.hostname"))
          this.$set(values, "hostname", object.field_values.hostname);
        this.$set(values, "id", object.id);
        break;
      case UpmindObjectTypes.PRIORITY:
      case UpmindObjectTypes.STATUS:
        this.$set(values, "name", object.name);
        this.$set(values, "code", object.code);
        this.$set(values, "id", object.id);
        break;
      case UpmindObjectTypes.USER:
        this.$set(values, "name", object.name);
        this.$set(values, "email", object.email);
        this.$set(values, "id", object.id);
        break;
      default:
        this.$set(values, "name", object.name);
        this.$set(values, "id", object.id);
        break;
    }
    return _.map(
      values,
      (value, key) => `${_.upperFirst(key.replace(/_/, " "))}: ${value}`
    ).join("\n");
  }
}
